/* eslint-disable no-param-reassign */
import styled from '@emotion/styled'
import * as React from 'react'
import { transparentize } from 'polished'
import { navigate } from 'gatsby'
import { HeaderLogoGroup, StyledHeader } from './Header'
import { breakpoints, colors, heights } from '../styles/variables'
import CloseIcon from '../images/svgs/Close.svg'
import { breakpointMq, getEmSize } from '../styles/mixins'

const StyledScrollableHeader = styled(StyledHeader)(() => ({
  justifyContent: 'space-between',
  position: 'fixed',
  transition: 'all 200ms',
  zIndex: 1,
  backgroundColor: transparentize(0.1, colors.white),
  boxShadow: `0px 0px 4px ${transparentize(0.8, 'black')}`,
  backdropFilter: 'blur(4px)'
}))

const CloseButton = () => (
  <button
    type="button"
    onClick={() => navigate('/')}
    css={{
      display: 'flex',
      background: 'none',
      border: 'none',
      alignItems: 'center',
      justifyContent: 'center',
      WebkitTapHighlightColor: 'transparent',
      transition: 'all 200ms ease-out',
      '.icon': {
        transition: 'all 200ms ease-out',
        fill: colors.gray.calm
      },
      '&:active, &:hover': {
        borderColor: colors.brand,
        '.icon': {
          fill: colors.brand
        }
      },
      padding: '0 !important',
      flex: '0 0 auto',
      [`${breakpointMq(breakpoints.xxs, breakpoints.sm)}`]: {
        width: `${getEmSize(42)}rem`,
        height: `${getEmSize(42)}rem`
      },
      width: `${getEmSize(56)}rem`,
      height: `${getEmSize(56)}rem`
    }}
  >
    <CloseIcon
      className="icon"
      css={{
        '&:active': { fill: colors.brandLight },
        [`${breakpointMq(breakpoints.xxs, breakpoints.sm)}`]: {
          width: `${getEmSize(16)}rem`,
          height: `${getEmSize(16)}rem`
        },
        width: `${getEmSize(20)}rem`,
        height: `${getEmSize(20)}rem`
      }}
    />
  </button>
)

const StyledSpacer = styled.div({
  height: `${heights.header}rem`,
  [`${breakpointMq(breakpoints.xxs, breakpoints.sm)}`]: {
    height: `${heights.headerMobile}rem`
  }
})

const StickyHeader: React.FC = () => {
  const headerEl = React.createRef<HTMLElement>()

  return (
    <>
      <StyledSpacer />
      <StyledScrollableHeader ref={headerEl}>
        <HeaderLogoGroup />
        <CloseButton />
      </StyledScrollableHeader>
    </>
  )
}

export default StickyHeader
